import { useFeatureFlagsContext } from '@app/contexts';
import { getMatchedFeatureFlag } from '@app/utils';
import { Feature, FeatureFlagToMatch } from '@app/constants';

export const useFeatureFlag = <T extends Feature>(
  flagToMatch: FeatureFlagToMatch<T>
) => getMatchedFeatureFlag({ flags: useFeatureFlagsContext(), flagToMatch });
